export default abstract class TableUuids {
  static readonly ADAM_ORDER_ITEMS = "41bb2996-2477-4e35-a11a-d52e9f3faedc";
  static readonly ADAM_SOURCES = "8ce70b4b-14ac-4130-b1d6-e653691aa78e";
  static readonly ADAM_TRAILERS = "d946adfc-24f1-4627-94d9-713306a4327b";
  static readonly CONFIG_ARCHIVE_HERITAGE_TAPE = "eb02bae1-24cf-48c3-8850-f7ff739c2796";
  static readonly DRIVE_ASSET_TABLE = "2e37e983-12e2-4dba-8234-d690a8eb8c42";
  static readonly INGEST_WORKFLOW_TABLE = "3c94781c-0aed-4b14-9f0e-46120e1e9d20";
  static readonly ASSET_SINGLE_SHARE_TABLE = "28394fe8-4a04-42b5-b79e-b5a650722780";
  static readonly ASSET_SINGLE_HIERARCHY = "238a5565-8db4-4bc4-a943-75efda8a4c05";
  static readonly ASSETS_TABLE = "546cdc22-0655-495a-955e-4ad325984719";
  static readonly JOBS_TABLE = "86dbaf47-f3bc-4fad-a686-b8d261dd9d20";
  static readonly MARKERS_TABLE = "0879346b-de1a-4c64-bd22-d6da6d63e395";
  static readonly ORDER_ITEMS_TABLE = "0dd7089b-083e-40e4-902f-5ded5e16760c";
  static readonly ORDER_TABLE = "ebd0f196-8acd-4db9-83c9-791bab575d81";
  static readonly PROVIDER_INGEST_TABLE = "fd4d6183-b342-4571-a68e-111a6ec7b729";
  static readonly TITLES_TABLE = "25dadc3d-d13a-4510-979d-c5c09ea09d1c";
  static readonly CUSTOMERS_TABLE = "e81cd52e-ff88-44ea-a987-a4f905224331";
  static readonly DASHBOARD_ACTIVITIES_TABLE = "3f4b87b5-7c55-4c7c-873c-04b8cbd992e3";
  static readonly DASHBOARD_APPROVALS_TABLE = "4fb5aacf-b02f-4f9c-b260-941fd58f55af";
  static readonly DASHBOARD_PURGES_TABLE = "bbd1dd20-af8d-4030-abbd-766f3810b986";
  static readonly DASHBOARD_QC_TABLE = "0115c82c-03c4-4cc0-ba1e-509d344c9aa6";
  static readonly INGEST_CONFIG_COLSET_TABLE = "c0fe2e67-9fcf-4362-b8e2-1a73a174b2c0";
  static readonly INGEST_CONFIG_PLACEHOLDER_TABLE = "5840db40-425f-4056-bffb-7ff3a97f6679";
  static readonly INGEST_PACK_SINGLE_TABLE = "12a12d7c-28ec-42ad-9d55-2349102b21d3";
  static readonly INGEST_REJECTED_TABLE = "e171f010-9424-4ee3-a3d9-5ce7e686a4fc";
  static readonly INGEST_REQUESTED_TABLE = "af20ac74-a98d-4e50-a74b-080a20a0dd07";
  static readonly ASSET_SINGLE_ACTIONS = "85ae1183-c936-4245-9635-223135e1a8c7";
  static readonly ASSET_SINGLE_MEDIA_FILES = "23d08411-e944-415d-9c1f-f14ad36fa4fe";
  static readonly ASSET_SINGLE_ORDERS = "94c4ab1d-632d-41f7-8fb7-a6aa09440ca8";
  static readonly INVENTORY_ADVANCED_QUERIES_CONTENTS = "10e24f17-2a31-4fe8-bd70-5292c57a6ca5";
  static readonly INVENTORY_BUNDLES = "56f94c5d-2258-49f6-a53d-6f98dd3aea69";
  static readonly INVENTORY_KDM_RECIPIENTS = "09c34090-ebe3-47fa-bc55-760c950db0db";
  static readonly TITLE_SINGLE_ASSETS = "df28be55-90f6-4f47-8115-cbc1e31f4ecc";
  static readonly TITLE_SINGLE_ORDERS = "4cc5e9fc-82ce-4b25-ab2a-cda818b3a3c5";
  static readonly TITLE_SINGLE_CONTRACTS = "be5cff5b-c69f-455c-85b6-b03f4b7df587";
  static readonly PROVIDERS_TABLE = "0c4f8418-eeaf-4789-ab80-1b140578b832";
  static readonly SETTINGS_BROADCASTERS_TABLE = "0c4f8418-eeaf-4789-ab80-1b140578b832";
  static readonly SETTINGS_EXPORT_SESSIONS = "de77f450-e492-4f2c-b7e7-d07fc38eae05";
  static readonly SETTINGS_FORMATS = "dee663de-5a8c-45e6-abf2-271b8d66b50a";
  static readonly SETTINGS_MAILING_LISTS = "244b85bc-58da-4384-bd89-539247748e6f";
  static readonly SETTINGS_MANUAL_TASKS_TEMPLATES = "27039fc0-0387-48c1-af90-eed9c9e35646";
  static readonly SETTINGS_MANUAL_TASKS_SERVICES = "bb9cc0fb-958f-4e37-96ae-1e7784a91b8d";
  static readonly SETTINGS_MANUAL_TASKS_TASKS = "8e7970b0-7751-4052-857c-493fb9307406";
  static readonly SETTINGS_METADATA_FIELDS = "02d5c113-eed9-4441-bf5e-65607a01cf65";
  static readonly SETTINGS_METADATA_VIEWS = "d95a516c-2902-44d4-938b-accc867a98a5";
  static readonly SETTINGS_PLANNING_RESOURCES = "d6d90f58-b420-492b-b46e-a8135b5ac041";
  static readonly SETTINGS_PRICE_RULES = "ac5b85c6-d47e-49d7-a7b7-092bb0fc85d4";
  static readonly SETTINGS_PRODUCTS = "5b0214cd-b128-425e-9133-557aabc933c6";
  static readonly SETTINGS_PURGE_RULES = "61142630-3b49-4c44-b021-86ae795b221e";
  static readonly SETTINGS_ROLE_AND_PERMISSIONS = "c47a85e0-53b5-4ddc-9627-8f471ef71f59";
  static readonly SETTINGS_STATUS_TRANSITIONS = "cdf913ea-34c4-44d2-ad42-235f4769fc41";
  static readonly SETTINGS_STORAGES = "38c33b15-0c5b-422a-ad7d-83e54ee31111";
  static readonly SETTINGS_SYSTEM_ALERTS = "a0da8898-dda9-4986-b212-fe750efef564";
  static readonly SETTINGS_SYSTEM_CULTURES = "5859980e-e2b0-426a-b569-b23d697f6937";
  static readonly SETTINGS_USERS = "557259d2-f19e-4327-9c35-368fa42ee293";
  static readonly SETTINGS_WORFKLOWS = "557259d2-f19e-4327-9c35-368fa42ee293";
  static readonly SETTINGS_YOUTUBE_CHANNELS = "50469c81-ebb8-4bb0-ab60-0327e71b586f";
  static readonly SHARES_TABLE = "3b05ae66-a766-4f05-954c-530cb3185797";
  static readonly BILLING_EXPENSE_TABLE = "dc8bf219-9fd5-4ca3-955b-dc7d9e6f0f34";
  static readonly BILLING_INVOICES = "808dcfc8-39ea-46ad-bfe9-7d742cbdde03";
  static readonly CONTRACTS_TABLE = "2529371b-fe28-4edc-bc93-144387ee31ba";
  static readonly DRIVE_EXTERNAL_ACCESS = "f959744e-4e66-41ff-9132-3ba5c69ea756";
  static readonly DRIVE_TRASH = "f599765f-6ddc-4e26-a18f-11f4691a5991";
  static readonly ORDERS_WATERMARKS = "c1372102-8fbf-4bff-ba09-2a1edcd996d7";
  static readonly NEW_REQUEST_PLACEHOLDER_MARKETPLACE = "ebcaa553-342e-4840-982e-dfdb78711169";
}

//

//

//

//

//

//

// ebcaa553-342e-4840-982e-dfdb78711169

// db99eaac-1919-4302-b801-5887ab3dd60d

// 1c0636f7-7235-4d80-a371-bd798f7a7105

// 8b14bd13-90b0-4de7-877b-1fe18f20dd1d

// 1a99019b-becb-4452-be2c-c290bef481ca

// 28bdddbc-d117-40bb-a4cc-56e128ee3874

// 4b4c3e0a-8f76-42ad-82b9-836bd20ba399

// 4d1042ae-620c-415f-8bb2-ba0279ddc017

// 4d640ff4-ceeb-492b-b7f5-c8b5f29a66f5

// 87ac7837-73e3-4354-b34d-dd6aa4e623bb

// 2bb256b6-63ec-4f89-aa81-d0b179fd499a

// 0886a905-fb85-4532-8fb4-708a370efafd

// 94273d71-c789-4d39-825b-97f8d877d1a9

// 9e09b00f-2c32-4512-8f2c-6017caf50320

// d3a58917-8996-40c2-a06b-1d8f1193ab94

// dd34a0e1-1b3b-4288-a5c2-66df8f2c6d48

// e4b7b95d-6b1d-48a3-98c5-f056e05876e1

// 5ea9e2a1-e8a1-40dd-a3b2-bc5ada2488e0

// ecca995f-acf6-4d00-a9eb-53205687abcd

// 708fab42-ae4b-4dcf-990d-5c7bda9a8686

// 6777c1c8-7541-4752-b1ca-5132be44f2af

// ba5e8693-0bf3-470a-9d0c-ddce5ad06677

// 8d17b362-d220-4c67-9795-675a7702b9e7

// 873c74a3-fd49-40d6-98e8-ab45b19692a0

// 39fe9c7d-957b-4892-8605-af11efed1b46

// 8f9406f3-2c1d-47d8-a47a-93d3e77938ef

// f26d58ac-3868-45eb-9780-f7dc214c7660

// bb0815f7-412a-4223-9853-5f9210c07a32

// 5022d57f-3a28-4a9a-aaac-a82602b7bfac

// 5fedfab2-f7ef-4e2e-9516-7ef864bbdab9

// fd13fc97-d4ba-4d35-9a80-14183ba68748

// abdf19d5-f511-4287-b761-c2e4ecddd860

// eb9c5b7a-cd6b-455f-bccd-c3fba4b792e6

// 07024bb5-5c7a-43c4-8596-86399d5fa145

// 379cded6-828e-4992-aaaf-d9e45c75f023

// 7cf379ce-9680-4f43-b8e7-e11feb9aea34

// f0631ec6-e336-4efa-a6fb-de81a9c8143c

// 252c9e2e-4f34-4c6b-9368-bb712889552a
